import { useAppsSectionResize } from './useAppsSectionResize.js'

export function useAppsSectionModel({ showAll = false, apps = [], onAppClick } = {}) {
  const title = showAll ? 'All Apps' : 'Build'
  const resize = useAppsSectionResize()

  return {
    title,
    resize,
    showAll,
    apps,
    onAppClick,
  }
}
